import { render } from "./DemoBlock.vue?vue&type=template&id=36b16855"
import script from "./DemoBlock.vue?vue&type=script&lang=js"
export * from "./DemoBlock.vue?vue&type=script&lang=js"

import "./DemoBlock.vue?vue&type=style&index=0&id=36b16855&lang=less"
script.render = render

export default script